import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ReviewCard from '../ReviewCard';
import {
  getSessionStorageItem,
  setSessionStorageItem,
} from '../../operations/sessionStorage/utils';
import {
  SESSION_STORAGE_BOOKING_PROFILE_NAME,
  SESSION_STORAGE_CURRENT_BOOKING,
  SESSION_STORAGE_GDS_LOCATOR,
  SESSION_STORAGE_CURRENT_DATA_FLIGHT,
  SESSION_STORAGE_CURRENT_EXTRADATA_FLIGHT,
  SESSION_STORAGE_FLIGHT_TYPE_CODE,
  FLIGHT_TYPE_CODES,
} from '../../utils/constants';

const FlightDetails = ({
  title = '',
  isChangeFlights = false,
  isSummary = false,
  setExpandedChange = () => {},
  expandedChange,
  cardTitle = '',
  isNewDeparting = false,
  isChange,
}) => {
  const [currentChangeData, setCurrentChangeData] = useState(null);
  const [currentChangeExtraData, setCurrentChangeExtraData] = useState(null);

  const flightTypeCodeFromSession = getSessionStorageItem(SESSION_STORAGE_FLIGHT_TYPE_CODE);
  const isOneWaySelected = flightTypeCodeFromSession === FLIGHT_TYPE_CODES.ONE_WAY;
  useEffect(() => {
    const bookingProfileSession = getSessionStorageItem(SESSION_STORAGE_BOOKING_PROFILE_NAME) || {};
    const currentBooking =
      bookingProfileSession || getSessionStorageItem(SESSION_STORAGE_CURRENT_BOOKING) || {};

    if (!currentBooking) {
      return null;
    }

    let flightsAvailable = -1;
    const guestsInFlight = [];
    const gdsLocatorsArrays = getSessionStorageItem(SESSION_STORAGE_GDS_LOCATOR);
    currentBooking?.flightProfile?.guests?.forEach((guest, i) => {
      if (
        gdsLocatorsArrays &&
        guest.flightGuest?.gdsLocators?.some((gdslocator) => gdslocator === gdsLocatorsArrays[0])
      ) {
        flightsAvailable = i;
        guestsInFlight.push(guest);
      }
    });
    if (flightsAvailable === -1 && isChangeFlights) {
      return null;
    }
    const categorizedFlights = currentBooking?.flightProfile?.guests[
      flightsAvailable
    ]?.flightGuest?.guestFlights.reduce((result, flight) => {
      /* eslint-disable no-param-reassign */
      result[flight.routeDirection.toLowerCase()] = flight;
      return result;
    }, {});

    const createOperatingAirlines = (flight) => {
      const segment = flight?.flightSegments[0]?.operatingAirline;
      return {
        name: segment?.name,
        code: segment?.code,
        icon: segment?.icon,
      };
    };

    const createCabin = (flight) => {
      const segment = flight?.flightSegments[0];
      return {
        passengerQty: guestsInFlight?.length,
        cabinClass: {
          code: segment?.cabinClass.code,
          name: segment?.cabinClass.name,
        },
      };
    };
    const totalPriceChangeFlight =
      (currentBooking?.flightProfile?.guests[flightsAvailable]?.flightGuest?.airChargesAmount ||
        0) * (guestsInFlight?.length || 0);
    const dataCurrent = {
      inboundFlight: categorizedFlights?.inbound,
      outboundFlight: categorizedFlights?.outbound,
      priceChange: null,
      isOneWay: categorizedFlights?.inbound === undefined,
    };

    const extraDataCurrent = {
      departureFlight: {
        flight: {
          operatingAirlines: [createOperatingAirlines(categorizedFlights?.outbound)],
          flightSegments: categorizedFlights?.outbound?.flightSegments,
          departDate: categorizedFlights?.outbound?.departDate,
        },
        cabin: createCabin(categorizedFlights?.outbound),
      },
      returnFlight: {
        flight: {
          operatingAirlines: [createOperatingAirlines(categorizedFlights?.inbound)],
          flightSegments: categorizedFlights?.inbound?.flightSegments,
          departDate: categorizedFlights?.inbound?.departDate,
        },
        cabin: {
          ...createCabin(categorizedFlights?.inbound),
          pricePerPassenger: {
            value:
              currentBooking.flightProfile.guests[flightsAvailable]?.flightGuest.airChargesAmount,
            currency: currentBooking.flightProfile.currency,
          },
          totalPrice: {
            value: totalPriceChangeFlight,
            currency: currentBooking.flightProfile.currency,
          },
          currency: currentBooking.flightProfile.currency,
        },
      },
    };

    setCurrentChangeData(dataCurrent);
    setSessionStorageItem(SESSION_STORAGE_CURRENT_DATA_FLIGHT, dataCurrent);
    setCurrentChangeExtraData(extraDataCurrent);
    setSessionStorageItem(SESSION_STORAGE_CURRENT_EXTRADATA_FLIGHT, extraDataCurrent);
    return false;
  }, []);
  const isOneWay = isNewDeparting ? isOneWaySelected : currentChangeData?.isOneWay;
  if (currentChangeData) {
    return (
      <ReviewCard
        isNewDeparting={isNewDeparting}
        data={currentChangeData}
        extraData={currentChangeExtraData}
        title={title}
        isChangeFlights={isChangeFlights}
        isSummary={isSummary}
        isDesktop={expandedChange}
        handleAccordion={() => setExpandedChange(!expandedChange)}
        cardTitle={cardTitle}
        isOneWay={isOneWay}
        isChange={isChange}
      />
    );
  }
  return null;
};

FlightDetails.propTypes = {
  title: PropTypes.string,
  isChangeFlights: PropTypes.bool,
  isSummary: PropTypes.bool,
  expandedChange: PropTypes.bool,
  setExpandedChange: PropTypes.func,
  cardTitle: PropTypes.string,
  isNewDeparting: PropTypes.bool,
};

export default FlightDetails;
